var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWarningTriangleFilled = function SvgWarningTriangleFilled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.08 15.33 15 2.57A3.67 3.67 0 0 0 12 1c-1.19 0-2.32.58-3.03 1.6L.93 15.31c-1.02 1.46-1.21 3.21-.5 4.56.7 1.35 2.17 2.12 4.01 2.12h15.12c1.85 0 3.31-.77 4.01-2.12s.51-3.09-.49-4.54M11 7c0-.55.45-1 1-1s1 .45 1 1v6c0 .55-.45 1-1 1s-1-.45-1-1zm1 12c-.83 0-1.5-.67-1.5-1.5S11.17 16 12 16s1.5.67 1.5 1.5S12.83 19 12 19"
  })));
};
export default SvgWarningTriangleFilled;